import { InvoiceStatus } from "../../../types/invoice";
import { StatusFilter } from "../../../types/statusFilter";
import { createStatusFilterSchema } from "../../status-filter.schema";

export const InvoiceStatusFilterSchema =
    createStatusFilterSchema(InvoiceStatus);

export type InvoiceStatusFilter = StatusFilter<InvoiceStatus>;
